<template>
  <div v-if="!noCustomer">
    <v-app-bar color="light-blue darken-2" dense dark app>
      <v-toolbar-title>
        <v-btn
          color="light-blue darken-2"
          elevation="0"
          style="font-size: 1.25rem"
        >
          {{ cusName }}
        </v-btn>
      </v-toolbar-title>

      <v-spacer></v-spacer>
      <v-btn
        color="light-blue darken-2"
        class="mt-2"
        elevation="0"
        @click="report()"
      >
        <v-icon class="mr-2">mdi-monitor-dashboard</v-icon>รายงานเก็บขยะ /
        ใบแจ้งหนี้
      </v-btn>
      <v-btn
        color="light-blue darken-2"
        class="mt-2"
        elevation="0"
        @click="debt()"
      >
        <v-badge :color="cbill > 0 ? 'red' : ''" overlap left :content="cbill">
          <v-icon class="mr-2">mdi-account-cash-outline</v-icon>ยอดค้างชำระ
        </v-badge>
      </v-btn>
      <br />
    </v-app-bar>
    <div v-if="showReport">
      <LinkCusBillReport />
    </div>
    <div v-else>
      <LinkCusBill />
    </div>
  </div>
  <div v-else>
    <v-container fill-height fluid>
      <v-row align="center" justify="center">
        <center>
          <v-img width="400px" src="@/assets/warning.png"></v-img>
          <h1>ไม่พบลูกค้า / ลูกค้ายังไม่ได้ทำสัญญา</h1>
        </center>
      </v-row>
    </v-container>
  </div>
</template>

<script>
import LinkCusBillReport from './forms/LinkCusBillReport'
import LinkCusBill from './forms/LinkCusBill'

export default {
  name: "CustomerLink",
  components: {
    LinkCusBillReport,
    LinkCusBill
  },
  data() {
    return {
      showReport: true,
      noCustomer: false,
      showDebt: false,
      cusName: "",
      cbill:0,
    };
  },
  created() {
    const cid = this.$route.params.cus_id
    //view-customer-by-id
    this.getCustomer(cid)
    this.list_bill(cid)

  },
  methods: {
    getCustomer(cus_id) {
      this.$token_api.post("/view-customer-by-id", { CUSTOMER_ID: cus_id })
        .then((response) => {
          let cus_data = response.data.data[0]
          if (typeof (cus_data) == 'object') {
            this.cusName = cus_data.CUSTOMER_NAME
          } else {
            this.noCustomer = true
          }


        })
        .catch((err) => {

        });
    },
    report() {
      this.menuCondition('report')
    },
    debt() {
      this.menuCondition('debt')
    },
    list_bill(cus_id) {
      this.$token_api.post("/list-customer-bill", { CUSTOMER_ID: cus_id })
        .then((response) => {
          let bill_data = response.data.data;
          let count_bill = bill_data.filter((item) => {
            return item.INVOICE_ID != null && item.STATUS != 'PAID' && item.STATUS != 'REQUESTED'
          })
          this.cbill = count_bill.length
        }).catch((err) => { });

    },
    menuCondition(menu) {
      if (menu == 'report') {
        this.showReport = true
        this.showDebt = false
      } else {
        this.showReport = false
        this.showDebt = true
      }
    }

  },
};
</script>
